import { render, staticRenderFns } from "./JoyIcon.vue?vue&type=template&id=c8c9d506&"
import script from "./JoyIcon.vue?vue&type=script&lang=js&"
export * from "./JoyIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports